<div class="max-w-6xl mx-auto px-4">
  <div class="mb-6 lg:mb-12">
    <mobo-partner-banner></mobo-partner-banner>
  </div>
  <div class="flex justify-between items-center mb-14">
    <div
      class="text-slate-800 text-3xl font-semibold tracking-tight"
    >
      QUEM JÁ É PARCEIRO
    </div>
    <button
      *ngIf="appService.showFeature('slugs')"
      (click)="webappService.saveSlugs()"
      class="rounded-md px-2 py-2 text-base font-medium text-primary-500 ring-2 ring-primary-500 hover:bg-primary-500 hover:text-white"
    >
      Gerar Slugs
    </button>
  </div>
  <div class="grid grid-cols-2 lg:grid-cols-6 gap-2">
    <div
      *ngFor="let restaurant of webappService.restaurants | async"
      class="flex flex-col items-center justify-start text-center group cursor-pointer px-2 py-4 gap-3 rounded-lg ring-primary-500 hover:ring-2 transition-all"
      (click)="redirectToRestaurant(restaurant.SluggedTradeName)"
    >
      <img
        class="rounded-full mb-3 bg-slate-200"
        [ngSrc]="restaurant?.LogoImagePath || defaultImg"
        width="80"
        height="80"
        [alt]="restaurant?.TradeName"
      />
      <div
        class="text-base font-medium tracking-tight group-hover:text-primary-500"
        [title]="restaurant?.TradeName"
      >
        {{ restaurant?.TradeName }}
      </div>
    </div>
  </div>
</div>
